import { defineStore } from "pinia";
import { Ref, ref, watch } from "vue";

export const useInterfaceStore = defineStore("interface", () => {
    // Data
    const isYoutubeIframeScriptLoaded: Ref<boolean> = ref(false);
    const isYoutubeIframeScriptBeingLoaded: Ref<boolean> = ref(false);
    const isYouTubeIframeAPIReady: Ref<boolean> = ref(false);
    const menuClass = ref("");
    const mobileMenuOpen: Ref<boolean> = ref(false);

    // Methods
    function loadYoutubeIframeScript() {
        if (!isYoutubeIframeScriptLoaded.value && !isYoutubeIframeScriptBeingLoaded.value) {
            // Prevent this logic from being triggered from multiple methods at the same time
            isYoutubeIframeScriptBeingLoaded.value = true;

            const tag = document.createElement("script");
            const firstScriptTag = document.getElementsByTagName("script")[0];

            tag.src = "//www.youtube.com/iframe_api";
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            isYoutubeIframeScriptLoaded.value = true;
            isYoutubeIframeScriptBeingLoaded.value = false;
        }
    }

    function changeMenuClass(newClass: string) {
        let appElement = document.getElementById("app");

        if (menuClass.value !== "") {
            appElement.classList.remove(menuClass.value);
        }

        menuClass.value = newClass;

        if (menuClass.value !== "") {
            appElement.classList.add(menuClass.value);
        }
    }

    return {
        menuClass,
        isYoutubeIframeScriptLoaded,
        isYouTubeIframeAPIReady,
        changeMenuClass,
        mobileMenuOpen,
        loadYoutubeIframeScript,
    };
});
